import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function getNewCommissionMonth() {
    const response = await axios.get(`${MONTHLY_COMMISSIONS_ENDPOINT}/calculate-new-month`);
    return response.data.data
}